import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Components
import Button from '../Button/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  text-align: center;
  font-family: 'Roboto', sans-serif;
`;

const Message = styled.p`
  font-size: 20px;
  margin-bottom: 30px;
`;

const Fallback = () => {
  const { t } = useTranslation();
  return (
    <Container translate="no">
      <Message>{t('crashMessage')}</Message>
      <Button onClick={() => window.location.reload()}>{t('reloadPage')}</Button>
    </Container>
  );
};

// Shows a reload screen instead of a blank page when rendering crashes
// (e.g. when Chrome's page translation rewrites nodes React manages).
class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
  }

  render() {
    return this.state.hasError ? <Fallback /> : this.props.children;
  }
}

export default ErrorBoundary;
